import { render, staticRenderFns } from "./mediathek.vue?vue&type=template&id=e31683d4&"
import script from "./mediathek.vue?vue&type=script&lang=ts&"
export * from "./mediathek.vue?vue&type=script&lang=ts&"
import style0 from "./mediathek.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports